import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const LinkButton = ({ title, link, hoverStyle = 'white', color }) => {
  if (link.startsWith('http')) {
    return (
      <a href={link} className={cx('button', hoverStyle, color)} target="_blank" rel="noreferrer">
        {title}
      </a>
    );
  }

  return (
    <Link to={link} className={cx('button', hoverStyle, color)}>
      {title}
    </Link>
  );
};

export default LinkButton;
